module.exports = __webpack_public_path__ + "img/banner.d6ce99b1.png";